export default __webpack_public_path__ + "static/media/Standard.95c121ef.webp";